import { PassageStemModalContainer } from "@features/session/containers/PassageStemModalContainer";
import { StatusBar } from "expo-status-bar";

const StimulusRoute = () => {
	return (
		<>
			<PassageStemModalContainer />
			<StatusBar style="light" />
		</>
	);
};

export default StimulusRoute;
